// 단계별 오픈 기능 플래그 — Firestore config/features 문서 기반
// phase(레거시, 동결): 1=자동 거래명세서, 2=해외디자인 수주, 3=치과 의뢰접수·에이전트, 4=기공소 매칭·테스트보철
//   — 구 phase는 기존 사용처(PhaseRoute·phaseOpen: 테스트보철·글로벌 등) 전용으로 동결. **신규 게이트는 stage 사용**.
// stage(신설, 2026-08-20 대표 확정 상용화 단계표 — docs/점검_상용화_기능단계_2026-08.md):
//   0=기본 개방(명세서·계산서·예상매출·의뢰서·제작현황·재제작분석·거래처·덴클 프로그램)
//   1=파일 전송·재택(재택 디자이너), 2=치과 의뢰서 자동화(치과 스캔 수집), 3=디자인 외주(외주 의뢰서+디자이너 찾기 매칭)
//   오픈 = config/features.stage 값을 올리는 것 (배포 불필요). 미설정=0(잠금) — 베타는 stageOpen이 항상 통과.
// betaEmails / betaUserIds: 단계와 무관하게 전체 기능을 쓰는 베타 계정(아이반 기공소 + 연결 치과)
// 오픈 = 이 문서의 stage 값을 올리는 것 (배포 불필요). 베타 추가 = betaEmails/betaUserIds에 추가.
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { isAdminUser } from './adminClaim';
import { TERMS_V71_NOTICE_AT_MS } from '../config/termsV71';   // 약관 v7.1 공고일 00:00 KST (문안·날짜 한 곳 — config/termsV71.js 는 이 파일을 import 하지 않음)

// labOutsource: 국내 CAD 디자인 외주 — phase 2 묶음이지만 별도 스위치로 이중 게이트 (오픈 = config/features.labOutsource=true)
// pgProvider: 결제사 스위치 'kispg'|'toss' — 기본 kispg 유지, toss는 샌드박스 테스트용 (2026-08 토스 전환 선행 개발)
// clinicScanIntake: 치과 스캔 수집(치과 PC 스캔 감지·의뢰서 연결) — 2026-08-08 대표 지시로 기본 숨김.
//   기능 삭제가 아니라 화면만 감춘 것. 재개 = config/features.clinicScanIntake=true (배포 불필요)
// qrCheck: 공정 체크(체크 6종·QR) — 2026-08 개발 중, 기본 OFF. 오픈 = config/features.qrCheck=true (배포 불필요)
// caseUnify: 케이스 중심 통일 (docs/기획서_케이스중심통일_2026-08.md)
//   read  = 통합 뷰(utils/caseView.js) 섀도 비교 켜기. **화면 출력은 바뀌지 않는다** — 현행 결과와의 차이만 콘솔 로깅.
//           1단계에서 diff 0이 확인되면 그때 표시를 통합 뷰로 스위치한다(그 전환은 별도 배포).
//   write = 2단계용(agent_auto 자동등록 중단). 1단계에서는 사용하지 않음 — 기본 true(현행 유지)
// labPromoWaitlist: 프리미엄 홍보(치과 원장 화면 상단 배너, 지역별 근접 노출, 월 10만원) '사전 신청' 수집.
//   지금은 신청만 받고 과금·배너 노출 없음(50곳 이상 모이면 시작). 기본 OFF — 베타 계정은 항상 노출,
//   전체 lab에 노출하려면 config/features.labPromoWaitlist=true (배포 불필요). 오픈은 대표가 플래그 ON.
// missingClaims: 누락 청구 감지(기공소 대표 전용, 조회+소장 확인 저장만) — 2026-08-17 대표 확정.
//   기본 OFF(베타 노출). 오픈 = config/features.missingClaims=true (배포 불필요).
// jigLocal: 지그 생성 — (b) 기공소 내부망 방식. 웹에는 환자정보가 흐르지 않는다(안내 + 로컬 뷰어 http://127.0.0.1:8787 열기 링크만).
//   실제 결과 목록·다운로드는 기공소 PC 로컬 화면(덴클 로그인 게이트)에서 본다. 기본 OFF(베타 노출) — 오픈 = config/features.jigLocal=true (배포 불필요).
// jigWeb: 지그 결과 — (a) 클라우드 2주 보관 방식. (b) jigLocal 과 **독립**(둘 다 켤 수 있음, 서버 계약 docs/계약_지그웹a_클라우드보관_2026-10.md §0).
//   이 화면(/jig)에는 환자정보(치과·환자명·치식)가 보인다 — jigResults(본인 labId) 문서에서만 온다. 기공소 전용·환자 비노출 화면.
//   ⚠️ 켜기 전 게이트: 처리방침 [치과 지그 결과의 처리] 절 시행·고지 경과 + 서버 rules/함수 배포(계약 §8). 기본 OFF(베타 미리보기 허용).
//   오픈 = config/features.jigWeb=true (배포 불필요) — 서버 completeJigJob 의 보관 스위치와 같은 이름이어야 한다.
// clinicSubscription: 치과 구독 잠금(ClinicSubGate) 스위치 — 2026-08-17 대표 확정(약관 v6.0), 2026-10-04 요금 변경으로 신규 치과 월 99,000원(약관 v6.2).
//   기본 OFF = 치과 전 기능 무료(현행 그대로). ON이어도 잠기는 것은 요금표(subscriptionTariffs)가 있는 신규 치과의 체험 종료 후뿐 —
//   요금표 없는 기존 치과·users.subscriptionExempt===true(관리자·스크립트 전용 필드)는 잠기지 않는다(utils/billingPolicy.js, 계획_요금변경 §3).
// outsourceFolderFlow: 폴더 중심 외주 자동 의뢰서(#38 v5) — 「연결폴더」 케이스를 웹이 자동 의뢰서 초안으로
//   나열하고 체크 일괄 전송(agentCommands outsource_list/outsource_send). 기본 OFF —
//   rules(type 화이트리스트)·에이전트 신규 명령 배포 전에는 켜면 안 됨. 오픈 = config/features.outsourceFolderFlow=true
// clinicSubscription ON은 대표 승인 완료 상태(2026-08-21 지시 3회)이나, 최종마스터 정지 명령으로 보류:
//   가입 화면(Register)의 v6.1 동의 문구 완성본(main.6cf37373)이 먼저 배포·정합 검증돼야 함 — P0 설명의무 모순 방지.
//   재개 절차: 메인 채널 정합 확인 → config/features.clinicSubscription=true (콘솔) 또는 이 기본값을 true로.
// clinicPatients: 치과 환자관리(QR 등록·명부·의뢰서 연결, docs/기획서_치과환자관리_2026-09-10.md) — 기본 OFF.
//   베타 계정은 미리보기 가능(isClinicPatientsOn). 오픈 = 약관 30일 고지 경과 후 config/features.clinicPatients=true (배포 불필요)
// docsDiagnosisEnabled: 서류함(P2-12) 종류 선택지에 '진단서·소견서' 노출 — 민감정보 재동의(cp-1.2) 정리 전까지 기본 OFF.
//   오픈 = config/features.docsDiagnosisEnabled=true (배포 불필요). 영수증·세부내역서·기타는 플래그와 무관.
// pgReviewUserIds: 결제사(토스페이먼츠) 가맹 심사용 계정 uid 목록 (2026-09-21). 이 계정만 allFree 예외 + 토스 결제창 강제 —
//   심사자가 정기결제 상품·빌링 결제창을 확인할 수 있게 함. 일반 사용자는 영향 없음. 심사 끝나면 목록 비우기(배포 불필요).
// patientIntake: 환자앱 「첫 방문 등록」 수신(치과 웹 오늘 카드·상세·옮겨 적음·설정 항목) — 2026-09-30 대표 승인.
//   기본 OFF. **베타 미리보기 없음(strict — 계약 docs/계약_첫방문등록_서버_2026-09-30.md §5)**: 서버도 같은 키만 본다.
//   오픈 = 약관 v7.0 고지 30일 경과 후 config/features.patientIntake=true (배포 불필요).
// patientSelfRegister: 환자앱 「등록 경로 v2」(앱에서 치과를 골라 등록 → 치과 명부 unconfirmed) — 서버 registerPatientToClinic 이 보는 키
//   (계약 docs/계약_등록경로v2_서버_2026-10-01.md §A-5, 기본 OFF, config 미생성). 웹은 이 키로 화면을 열지 않는다 —
//   확인·거절·목록(명부 '확인 대기'·「오늘」 카드)은 플래그 무관(§A-5).
// clinicWalkin: 치과 데스크 QR 「웹 접수」 공개 엔드포인트(resolveClinicWalkin·submitClinicWalkin) — 서버 계약 §B-7 이 보는 키
//   (기본 OFF, config 미생성). 위치약관 v1.2 공고 30일 경과 후 config/features.clinicWalkin=true (배포 불필요).
//   웹 화면(/walkin/:slug·설정 QR·「오늘」 접수 카드)은 **clinicWalkin 단독**으로 연다(isClinicWalkinOn) — 최종 판정은 서버(feature-off).
// clinicRecall: 치과 명의 재내원 안내(리콜) — 2026-10-01 대표 승인(기획서 docs/기획서_리콜알림_벤치마킹_2026-10-01.md, 서버 계약 docs/계약_리콜_서버_2026-10-01.md).
//   기본 OFF, config 미생성. **베타 미리보기 없음(strict)** — 서버 callable 도 같은 키만 보고 OFF면 feature-off. 치과 환자관리(clinicPatients)가 열려 있어야 함(isClinicRecallOn).
//   오픈 = §7 게이트(cp-1.5 동의 정본·약관 v7.0 30일 고지·변호사 Q1~Q3·앱 제출) 통과 후 config/features.clinicRecall=true (배포 불필요)
// patientFeedback: 「장착 후 확인」(환자 피드백) 치과 웹 화면 — 2026-10-02 대표 승인(기획서 docs/기획서_환자피드백_2026-10-01.md v2 §4,
//   서버 계약 docs/계약_장착후확인_서버_2026-10-02.md). 기본 OFF, config 미생성. **베타 미리보기 없음(strict)** — 서버 치과 callable 도
//   같은 키만 보고 OFF면 feature-off. 치과 환자관리(clinicPatients)가 열려 있어야 함(isPatientFeedbackOn).
//   오픈 = 기획 §9 게이트 ①~⑦ 통과 후 config/features.patientFeedback=true (배포 불필요)
// deskReception: 치과 「접수」(데스크 QR 대기 순서 — 메뉴 /reception·공개 /walkin/:slug 개편 화면·의뢰서 「오늘 접수」 연결) — 2026-10-03 대표 지시.
//   기본 OFF, config 미생성. **베타 미리보기 없음(strict)** — 공개 접수 서버도 같은 키만 보고 OFF면 feature-off라, 베타만 데스크를 열면 늘 빈 화면이 된다.
//   오픈 = 약관 v7.0 고지 30일 경과 후 config/features.deskReception=true (배포 불필요). 코드에서 켜지 않는다.
// careApp: 덴클 케어(분리 환자앱) 1차 — 치과 웹의 「환자 앱 등록 처리위탁 확인」 카드·「새 앱 등록 N명」 표시 (2026-10-04 계획_환자앱1차_통합 W1·W3).
//   기본 OFF, config 미생성. **베타 미리보기 없음(strict)** — 서버 게이트(위탁 확인·비공개 파일럿 목록)와 별개로 화면만 연다.
//   오픈 = 처리방침 v3.2.4 시행·서버 배포·파일럿 치과 확정 후 config/features.careApp=true (배포 불필요). 코드에서 켜지 않는다.
// careAppStoreLive: 덴클 케어 스토어 출시 여부 — 웹 데스크 접수 완료 화면 안내 줄(W4)·/p/c 착지의 새 앱 링크(W5).
//   기본 OFF. 켜도 config/careApp.js 스토어 주소가 비어 있으면 안내가 나오지 않는다(링크 없는 안내 = 허위 안내, 정본 K-2).
// careSearchLive: 덴클 케어 앱 「치과 찾기」 운영 여부(2026-10-05 정본 v2.6 §4-2) — /p/app 착지의 찾기 포함 등록 안내 문구 전환에만 쓴다.
//   웹은 서버 Secret(WALKIN_PHONE_SALT) 설정 여부를 알 수 없어 플래그로 받는다. 기본 OFF = 현행(데스크 QR만) 문구.
//   오픈 = 서버 찾기가 운영에서 실제 동작(search-unavailable 아님) 확인 후 config/features.careSearchLive=true (배포 불필요). 코드에서 켜지 않는다.
// roadmapEngine: 「진료 후 질문」 질문 로드맵 엔진 치과 웹 화면([진료 끝 ▾]·「질문 답」 탭·설정 카드·사이드메뉴 배지·직원 초대 고지) — 2026-10-06
//   (설계 docs/설계_질문로드맵엔진_2026-10-05.md, 웹 계약 docs/계약_질문로드맵_웹_2026-10-06.md). 기본 OFF, config 미생성. **베타 미리보기 없음(strict)** —
//   서버 callable 도 같은 키만 보고 OFF면 failed-precondition {code:'feature-off'}. 치과 환자관리(clinicPatients)가 열려 있어야 함(isRoadmapEngineOn).
//   OFF면 버튼·탭·설정·배지 전부 비노출(CF 호출 0). 오픈 = 게이트(동의 정본·위탁 1.2·약관 고지) 통과 후 config/features.roadmapEngine=true (배포 불필요). 코드에서 켜지 않는다.
// clinicExpectedStatement: 치과 「받은 명세서」 기간 예상 기공료(품목·환자명 포함 예상 명세서) 카드 — 2026-10-07 (기획 docs/기획서_치과_기간예상명세서_2026-10-07.md,
//   계약 docs/계약_기간예상명세서_웹_2026-10-07.md, 법무 docs/법무검토_치과_기간예상명세서_2026-10-07.md). 기본 OFF, config 미생성.
//   **베타 미리보기 없음(strict)** — 서버 getExpectedStatement 도 같은 키만 보고 OFF면 failed-precondition {code:'feature-off'}. OFF면 카드 자체 비노출(CF 호출 0).
//   오픈 = 기공소 통합 고지(배너 2차+카톡) 후 최소 7일 경과(법무 §7) → config/features.clinicExpectedStatement=true (배포 불필요). 코드에서 켜지 않는다.
// clinicExpectedStatementOpenAt: 위 기능 오픈 예정일(ISO 날짜 'YYYY-MM-DD' 등) — 기공소 고지 배너·설정 문구·치과 카드의 "{오픈일}" 자리에 표시만 한다(게이트 아님).
//   값이 없으면 "곧"으로 표시. 오픈일은 배포 후 대표가 정한다(2026-10-07 대표 결정) — 배너·카톡·플래그 ON 날짜 3곳 동일해야 함(법무 §6).
// clinicNotify: 치과 「치과 안내 보내기」(알림 파트 B, 2026-10-08 대표 승인 — 기획서 docs/기획서_환자자동관리_알림파트_2026-10-07.md). 기본 OFF, config 미생성.
//   **베타 미리보기 없음(strict)** — 서버 callable 도 같은 키만 본다. 치과 환자관리(clinicPatients)가 열려 있어야 함(isClinicNotifyOn). ON은 대표 결정(배포 불필요)
// doctorCall: 치과 「원장 호출」 1차 웹(접수 화면 3번째 카드·/call 진료실 격자·원장 응답 보기·데스크 띠·설정 › 원장 호출) — 2026-10-08 대표 지시
//   (명세 docs/명세_원장호출_웹_2026-10-08.md). 기본 OFF, config 미생성. **베타 미리보기 없음(strict)** — 카드가 사는 접수 화면(/reception)이 deskReception strict라
//   베타만 켜도 카드는 안 보이고 /call 만 열리는 반쪽이 된다. OFF면 카드·/call·띠·설정 전부 비노출(Firestore 구독 0). 오픈 = config/features.doctorCall=true (배포 불필요). 코드에서 켜지 않는다.
// careBooking: 치과 「예약」(/patients/bookings — 예약 요청 확정·거절·변경, 빈자리 알리기, 설정)·환자 상세 [본원 환자 확인] — 2026-10-11 대표 승인
//   (계획 docs/계획_케어앱_예약대기_2026-10-11.md W1·W2·W4). 기본 OFF, config 미생성. **베타 미리보기 없음(strict)**.
//   파일럿 여부는 비공개(adminConfig/careBookingPilot)라 웹은 이 플래그 + 서버 getClinicBookingSettings 의 available 1비트로만 판단(fail-closed).
//   켜기 = 법무 게이트(p-1.2·처리방침 시행, pa-clinic-1.3 확인 등 계획 §7) 통과 후 대표가 config/features.careBooking=true (배포 불필요). 코드에서 켜지 않는다.
// clinicPatientShareUi: 치과 설정 「환자 공개 범위」 카드(재료·기공소명·디자인 완료 알림 3스위치) — 2026-10-14 대표 승인(docs/착수계획_보철제작기록_2026-10-14.md §4-1 웹).
//   기본 OFF, config 미생성. **베타 미리보기 없음(strict)**. 저장·조회는 CF(getPatientShare·setPatientShare)만 — 서버 키와 별개로 화면만 연다. 코드에서 켜지 않는다.
// careAppReception: 케어 앱 QR [오늘 접수하기] — 치과 웹은 접수 화면 하단 안내에 "앱 접수" 표시만(배지 「앱 접수」는 서버 source 'app' 데이터 기준). 기본 OFF(strict).
const DEFAULTS = { phase: 1, stage: 0, labOutsource: false, pgProvider: 'kispg', pgReviewUserIds: [], clinicScanIntake: false, qrCheck: false, labPromoWaitlist: false, missingClaims: false, jigLocal: false, jigWeb: false, designResults: false, clinicSubscription: false, outsourceFolderFlow: false, clinicPatients: false, docsDiagnosisEnabled: false, patientIntake: false, patientSelfRegister: false, clinicWalkin: false, clinicRecall: false, clinicNotify: false, patientFeedback: false, deskReception: false, careApp: false, careAppStoreLive: false, careSearchLive: false, roadmapEngine: false, clinicExpectedStatement: false, clinicExpectedStatementOpenAt: null, doctorCall: false, careBooking: false, careAppReception: false, clinicPatientShareUi: false, outsourceMf: false, outsourceMfCncName: false, partnerHome: false, caseUnify: { read: false, write: true }, betaEmails: [], betaUserIds: [] };
const CACHE_MS = 5 * 60 * 1000;
let cache = null;
let cacheAt = 0;

// 중첩 객체(caseUnify 등)는 한 단계 더 병합한다 — 얕은 병합이면 config에 { caseUnify: { read: true } }만
// 넣었을 때 write 같은 하위 기본값이 통째로 사라진다(2026-08-09 전체회의 P1-11).
// 배열(betaEmails 등)과 스칼라는 문서 값이 그대로 이긴다.
const isPlainObject = (v) => !!v && typeof v === 'object' && !Array.isArray(v);
function mergeFeatures(defaults, data) {
    const out = { ...defaults };
    Object.keys(data || {}).forEach(k => {
        const dv = defaults[k], nv = data[k];
        out[k] = (isPlainObject(dv) && isPlainObject(nv)) ? { ...dv, ...nv } : nv;
    });
    return out;
}

export async function getFeatures() {
    if (cache && Date.now() - cacheAt < CACHE_MS) return cache;
    try {
        const snap = await getDoc(doc(db, 'config', 'features'));
        cache = snap.exists() ? mergeFeatures(DEFAULTS, snap.data()) : { ...DEFAULTS };
        cacheAt = Date.now();
        return cache;
    } catch (e) {
        // 미로그인/일시 오류로 읽기 실패 — 캐시하지 않고 보수적 기본값 + 실패 표시(_readFailed)를 반환
        // (로그인 직후 재시도가 5분 캐시에 막히면 베타 사용자가 권한을 잃는 문제 방지)
        // _readFailed=true: 요금 게이트(cardGate·billingPolicy)는 이 값을 보고 열림(fail-open)으로 처리한다 —
        //   기본값의 빈 베타 목록 때문에 베타·유료 고객이 잠기지 않게 (서버 resolveBilling 의 features_read_failed 와 같은 의미)
        console.error('[features] config/features 읽기 실패 — 기본값 사용(_readFailed):', e?.message || e);
        return { ...DEFAULTS, _readFailed: true };
    }
}

// 상용화 단계 게이트 (2026-08-20 대표 확정) — 베타(아이반+연결 치과+관리자+해외)는 항상 통과.
// 비베타는 config/features.stage >= min일 때만. features 미로딩(null)이면 보수적으로 잠금(베타 판정만 통과 가능).
export function stageOpen(min, features, userData, email) {
    if (isBetaUser(features, userData, email)) return true;
    return (features?.stage || 0) >= min;
}

// 치과 스캔 수집 노출 여부 — clinicScanIntake 플래그 && (베타 || stage 2 이상) (2026-08-20 대표 확정: 치과 스캔 자동 수집=stage 2)
// 플래그가 false면 베타 포함 전 계정 OFF(총괄 스위치 성격 유지). 플래그 ON이어도 비베타는 stage>=2 전까지 잠금.
// 사용처: 치과 메뉴 '최근 스캔', /clinic/scans 라우트, 의뢰서 작성(CreateOrder)·필기주문의 스캔 연결 UI, 치과용 에이전트 다운로드
export function isClinicScanIntakeOn(features, userData, email) {
    if (features?.clinicScanIntake !== true) return false;
    return stageOpen(2, features, userData, email);
}

// 케이스 통합 뷰 섀도 비교 켜짐 여부 (1단계). config/features.caseUnify.read=true 또는
// 개발자 임시 확인용 localStorage.caseUnifyRead='1' (내 브라우저에서만·화면 변화 없음)
export function isCaseUnifyRead(features) {
    if (features?.caseUnify?.read === true) return true;
    try { return typeof localStorage !== 'undefined' && localStorage.getItem('caseUnifyRead') === '1'; }
    catch (_) { return false; }
}

// 케이스 통합 뷰 표시 전환 (1단계 마무리, 2026-08-17 대표 확정 "신규가 옳다") —
// 명세서 작성·예상 매출의 화면 결과 자체를 통합 뷰(B)로 바꾼다. false로 내리면 즉시 현행(A) 복귀.
// config/features.caseUnify.display=true 또는 localStorage.caseUnifyDisplay='1'(내 브라우저 한정 시험)
export function isCaseUnifyDisplay(features) {
    if (features?.caseUnify?.display === true) return true;
    try { return typeof localStorage !== 'undefined' && localStorage.getItem('caseUnifyDisplay') === '1'; }
    catch (_) { return false; }
}

// 케이스 통일 2단계 — agent_auto 복사 주문을 계속 만들 것인가. 기본 true(현행 유지).
// config/features.caseUnify.write=false로 내리면 자동등록(복사 주문) 생성이 멈춘다 —
// 통합 뷰(display)가 케이스를 직접 읽으므로 명세서 내용은 그대로다. 롤백 = write:true.
export function isCaseUnifyWrite(features) {
    if (features?.caseUnify?.write === false) return false;
    try { if (typeof localStorage !== 'undefined' && localStorage.getItem('caseUnifyWriteOff') === '1') return false; }
    catch (_) { /* 무시 */ }
    return true;
}

// 치과 구독 유료화 개시 여부 (2026-08-17 대표 확정, 기본 OFF)
// false(기본)면 치과는 현행대로 구독 가드 전면 면제. true면 치과도 가드 대상이 되며,
// users.subscriptionExempt===true 회원만 면제(가드 쪽에서 함께 판정). features가 아직 안 읽혔으면(null) 보수적으로 OFF.
export function isClinicSubscriptionOn(features) {
    return features?.clinicSubscription === true;
}

// allFree = 비상 전원 무료 스위치 (2026-08-24 도입, 2026-10-04 의미 정정 — 계획_요금변경 W12).
// true면 구독 리다이렉트·치과 구독 잠금·세금계산서 카드 게이트·자동결제가 전부 열린다/멈춘다. 운영값은 false.
// 기존 고객 보호(기존 치과 무료·기존 기공소 2026-12-31까지 무료)는 이 스위치가 아니라 요금표 규칙
// (utils/billingPolicy.js ↔ functions/lib/billing-policy.js)이 담당한다 — 이 스위치를 꺼도 기존 고객은 잠기지 않는다.
export function isAllFree(features) {
    return features?.allFree === true;
}

// 요금 잠금이 실제로 적용되는가 — 가입 승인·결제 흐름 1단계 W1 (계획_가입승인결제흐름_2026-10-15 §3-1, 대표 승인 10-15).
//   대표 10-15 변경: 새 스위치(paywallMode)는 만들지 않는다 → 운영 개시 = 대표가 config/features.allFree 를 false 로 바꾸는 것(배포 불필요).
//   🔐 시스템보안 P2-5(10-15): allFree === false(boolean false 로 명시)일 때만 켜짐. 설정 문서 없음·null·형식 오류(문자열 등)·true → 꺼짐.
//   ⚠️ 서버 functions/lib/billing-policy.js · 앱 app_features.dart 의 paywallActive 와 같은 이름·같은 결과여야 한다.
//   isAllFree 는 옛 호출 호환용으로 남긴다.
export function paywallActive(features) {
    return !!features && features.allFree === false;
}

// 카드 등록 개시 시각 (2026-10-04 — 개인정보처리방침 v3.2.3 시행 2026-10-11 전에는 토스페이먼츠로 카드정보가 넘어가면 안 됨)
// config/features.billingOpenAt (ISO 문자열 · ms 숫자 · Timestamp) 로 바꿀 수 있다(배포 불필요).
// 값이 없거나 못 읽으면 기본 2026-10-11 00:00 KST — 설정 읽기 실패 시에도 열리지 않게(fail-closed) 기본값을 코드에 둔다.
export const DEFAULT_BILLING_OPEN_AT_MS = Date.parse('2026-10-11T00:00:00+09:00');
export function getBillingOpenAtMs(features) {
    const v = features?.billingOpenAt;
    let ms = NaN;
    if (typeof v === 'number') ms = v;
    else if (typeof v === 'string') ms = Date.parse(v);
    else if (v && typeof v.toMillis === 'function') ms = v.toMillis();
    else if (v && typeof v.seconds === 'number') ms = v.seconds * 1000;
    if (v !== undefined && v !== null && !Number.isFinite(ms)) {
        console.error('[features] billingOpenAt 형식 오류 — 기본 개시일(2026-10-11) 사용:', v);
    }
    return Number.isFinite(ms) ? ms : DEFAULT_BILLING_OPEN_AT_MS;
}
export function isBillingOpen(features, now = Date.now()) {
    return now >= getBillingOpenAtMs(features);
}

// 이용약관 v7.0 시행 시각 (2026-10-06 대표 결정 — 공고 2026-10-06, 30일 고지 후 시행 2026-11-06 00:00 KST).
//   정본 docs/정본_질문로드맵엔진_문서묶음_2026-10-06.md §3-0 (가) 병합 30일. billingOpenAt 과 같은 방식:
//   config/features.termsV70At (ISO 문자열 · ms 숫자 · Timestamp) 로 바꿀 수 있다(배포 불필요). 값이 없거나 못 읽으면 기본 2026-11-06.
//   시행 전 = /terms 는 현행 v6.2 를 보이고 v7.0 전문은 "개정 예정" 으로 함께 열람 가능, 공고 띠(로그인 화면·MainLayout) 노출.
//   시행 후 = /terms 가 v7.0 을 현행으로 보이고 공고 띠는 내려간다. ⚠️ 앞당기면 30일 고지가 깨진다 — 공고일 + 30일 이전으로 두지 말 것.
export const TERMS_V70_NOTICE_AT_MS = Date.parse('2026-10-06T00:00:00+09:00');
export const DEFAULT_TERMS_V70_AT_MS = Date.parse('2026-11-06T00:00:00+09:00');   // 법무 게시전 검토 §4-1: 초일불산입 +1일(11-05 → 11-06)
export function getTermsV70AtMs(features) {
    const v = features?.termsV70At;
    let ms = NaN;
    if (typeof v === 'number') ms = v;
    else if (typeof v === 'string') ms = Date.parse(v);
    else if (v && typeof v.toMillis === 'function') ms = v.toMillis();
    else if (v && typeof v.seconds === 'number') ms = v.seconds * 1000;
    if (v !== undefined && v !== null && !Number.isFinite(ms)) {
        console.error('[features] termsV70At 형식 오류 — 기본 시행일(2026-11-06) 사용:', v);
    }
    return Number.isFinite(ms) ? ms : DEFAULT_TERMS_V70_AT_MS;
}
export function isTermsV70Effective(features, now = Date.now()) {
    return now >= getTermsV70AtMs(features);
}
// 공고 띠 노출 기간: 공고일 00:00 ~ 시행 시각 전까지
export function isTermsV70NoticePeriod(features, now = Date.now()) {
    return now >= TERMS_V70_NOTICE_AT_MS && now < getTermsV70AtMs(features);
}

// 이용약관 v7.1 시행 시각 (CNC 파트너 — 제조업체·영업업체·회사 재판매. 정본 docs/약관_v7.1_개정안_CNC파트너_2026-10-24.md §3).
//   공고 2026-10-24(웹 배포일 D) · 30일 고지 · 시행 2026-11-24 00:00 KST(초일불산입 +1일 — v7.0 선례, 변호사 확인). termsV70At 과 같은 방식:
//   config/features.termsV71At (ISO 문자열 · ms 숫자 · Timestamp) 로 바꿀 수 있다(배포 불필요). 값이 없거나 못 읽으면 기본 2026-11-24.
//   공고일 상수 TERMS_V71_NOTICE_AT_MS 는 config/termsV71.js 에 있다(문안·날짜 한 곳). ⚠️ 공고일 + 30일 이전으로 당기지 말 것(30일 고지 깨짐).
//   v7.1 은 항상 v7.0 시행(11-06) 뒤다 — 두 시각의 선후를 코드가 강제하지는 않으므로 termsV71At 을 11-06 전으로 두지 말 것.
export const DEFAULT_TERMS_V71_AT_MS = Date.parse('2026-11-24T00:00:00+09:00');
export function getTermsV71AtMs(features) {
    const v = features?.termsV71At;
    let ms = NaN;
    if (typeof v === 'number') ms = v;
    else if (typeof v === 'string') ms = Date.parse(v);
    else if (v && typeof v.toMillis === 'function') ms = v.toMillis();
    else if (v && typeof v.seconds === 'number') ms = v.seconds * 1000;
    if (v !== undefined && v !== null && !Number.isFinite(ms)) {
        console.error('[features] termsV71At 형식 오류 — 기본 시행일(2026-11-24) 사용:', v);
    }
    return Number.isFinite(ms) ? ms : DEFAULT_TERMS_V71_AT_MS;
}
export function isTermsV71Effective(features, now = Date.now()) {
    return now >= getTermsV71AtMs(features);
}
// 공고 전 숨김 판정: 공고일 00:00 KST 전(빌드만 먼저 나간 경우)에는 v7.1 상자·판·띠를 그리지 않는다
export function isTermsV71Announced(now = Date.now()) {
    return now >= TERMS_V71_NOTICE_AT_MS;
}
// 공고 띠 노출 기간: 공고일 00:00 ~ 시행 시각 전까지
export function isTermsV71NoticePeriod(features, now = Date.now()) {
    return isTermsV71Announced(now) && now < getTermsV71AtMs(features);
}

// 이용약관 v8.0 전면 정비 (정본 docs/약관_v8.0_전문_초안_2026-10-24.md) — ★ 공고 전. 공고일은 변호사 회신 후 대표가 정한다.
//   공고일·시행일 모두 config/features 값으로만 정해지며 기본값이 없다: termsV80NoticeAt(공고일 00:00 KST)·termsV80At(시행 시각, 공고일+30일 초일불산입 — 변호사 확인).
//   ISO 문자열 · ms 숫자 · Timestamp 허용(getTermsV70AtMs 와 같은 방식). 둘 중 하나라도 없으면 「미정」 = v8.0 은 화면 어디에도 나타나지 않는다(상자·띠·버튼·조문·이력). 형식 오류는 console.error 후 미정 취급.
//   구현은 config/termsVersions.js(순수 함수 — node 검증용). ⚠️ termsV80At 을 공고일 + 30일 이전으로 두지 말 것(30일 고지 깨짐). termsV80NoticeAt 이 v7.1 시행(11-24) 전이면 v7.1 공고는 v8.0 공고로 대체된다.
export { getTermsV80NoticeAtMs, getTermsV80AtMs, isTermsV80Announced, isTermsV80Effective, isTermsV80NoticePeriod } from '../config/termsVersions';

// CAD 디자인 「연결형」 오픈 시각 (2026-10-16 대표 결정 — 처리방침 v3.2.8 공고 10-16·시행 10-23, 법무: 오픈은 시행일 이후).
//   config/features.cadConnectOpenAt (ISO 문자열 · ms 숫자 · Timestamp) 로 바꿀 수 있다(배포 불필요). billingOpenAt 과 같은 방식.
//   값이 없거나 못 읽으면 기본 2026-10-23 00:00 KST — 읽기 실패에도 먼저 열리지 않게(fail-closed). ⚠️ 시행일 전으로 당기지 말 것.
//   미리 보기: 관리자 + config/features.cadConnectPreviewUserIds(시험 계정, 회사 id 포함) 만. 베타(betaUserIds·아이반 등)는 실거래 회사라
//   시행 전에 열면 실제 환자 파일이 자동 전송될 수 있어 열지 않는다(법무 조건 그대로).
export const DEFAULT_CAD_CONNECT_OPEN_AT_MS = Date.parse('2026-10-23T00:00:00+09:00');
export function getCadConnectOpenAtMs(features) {
    const v = features?.cadConnectOpenAt;
    let ms = NaN;
    if (typeof v === 'number') ms = v;
    else if (typeof v === 'string') ms = Date.parse(v);
    else if (v && typeof v.toMillis === 'function') ms = v.toMillis();
    else if (v && typeof v.seconds === 'number') ms = v.seconds * 1000;
    if (v !== undefined && v !== null && !Number.isFinite(ms)) {
        console.error('[features] cadConnectOpenAt 형식 오류 — 기본 오픈일(2026-10-23) 사용:', v);
    }
    return Number.isFinite(ms) ? ms : DEFAULT_CAD_CONNECT_OPEN_AT_MS;
}
/** 연결형 화면을 이 사용자에게 보일지 — features 미로딩(null)이면 시각만으로(기본값) 판정 */
export function isCadConnectOpen(features, userData, now = Date.now()) {
    if (now >= getCadConnectOpenAtMs(features)) return true;
    if (userData && isAdminUser(userData)) return true;
    const ids = Array.isArray(features?.cadConnectPreviewUserIds) ? features.cadConnectPreviewUserIds : [];
    return !!userData && (ids.includes(userData.uid) || (!!userData.companyId && ids.includes(userData.companyId)));
}
/** 안내 문구용 "10월 23일" (한국 시각) */
export function cadConnectOpenLabel(features) {
    const k = new Date(getCadConnectOpenAtMs(features) + 9 * 3600 * 1000);
    return `${k.getUTCMonth() + 1}월 ${k.getUTCDate()}일`;
}

// 결제사 심사용 계정 여부 (config/features.pgReviewUserIds) — 구독 화면·설정 메뉴에서만 allFree 예외 + 토스 결제창 강제
export function isPgReviewer(features, uid) {
    if (!uid) return false;
    const list = Array.isArray(features?.pgReviewUserIds) ? features.pgReviewUserIds : [];
    return list.includes(uid);
}

// 시험 결제 계정 여부 (config/features.billingTestUserIds, 대표 10-15) — 구독 화면만 allFree 예외(서버 billing-policy isBillingTestUser 와 같은 목록)
export function isBillingTester(features, uid) {
    if (!uid) return false;
    const list = Array.isArray(features?.billingTestUserIds) ? features.billingTestUserIds : [];
    return list.includes(uid);
}

// opt.ignoreOverseas — 요금 게이트(구독·카드·치과 잠금)에서 요금표(subscriptionTariffs)가 있는 회원이면 true로 넘긴다.
//   labKind 는 본인이 고칠 수 있는 필드라, 요금표가 찍힌 국내 신규 회원이 'overseas'로 바꿔 요금 게이트를 빠져나가는 것을 막는다
//   (서버 decideBilling 판정 순서: 요금표 → overseas, 보안 P1-1). 메뉴·단계 노출 판정은 기존대로(옵션 없이) 호출.
export function isBetaUser(features, userData, email, opt = {}) {
    if (!userData) return false;
    if (isAdminUser(userData)) return true;
    // 해외 기공소는 글로벌 파일럿 계정 (가입 자체가 관리자 승인제)
    if (userData.labKind === 'overseas' && !opt.ignoreOverseas) return true;
    if (!features) return false;
    const mail = String(email || userData.email || '').toLowerCase();
    if (mail && (features.betaEmails || []).some(e => String(e).toLowerCase() === mail)) return true;
    const ids = features.betaUserIds || [];
    return ids.includes(userData.uid) || (userData.companyId && ids.includes(userData.companyId));
}

// 치과 환자관리 노출 여부 (2026-09-10) — 플래그 ON 또는 베타 계정(미리보기). features 미로딩(null)이면 잠금.
// 사용처: MainLayout 치과 슬림 메뉴 3곳 '환자 관리', App.js /patients 라우트, CreateOrder [명부에서 선택]
export function isClinicPatientsOn(features, userData, email) {
    if (!features) return false;
    if (features.clinicPatients === true) return true;
    return isBetaUser(features, userData, email);
}

// 지그 생성 노출 여부 (2026-10-19) — 플래그 ON 또는 베타(아이반) 계정. features 미로딩(null)이면 잠금.
// 웹 화면(/jig-local)은 환자정보 없는 정적 안내 + 로컬 뷰어 열기 링크뿐이라 서버/rules 게이트 없음(화면 노출만 제어).
export function isJigLocalOn(features, userData, email) {
    if (!features) return false;
    if (features.jigLocal === true) return true;
    return isBetaUser(features, userData, email);
}

// 지그 결과 (a) 클라우드 보관 화면 노출 여부 (2026-10-19) — 플래그 ON 또는 베타(아이반) 계정. features 미로딩(null)이면 잠금.
// 웹 화면(/jig)에는 환자정보가 보인다 — jigResults(본인 labId) 문서에서만 오고, Firestore/Storage rules 가 본인만 read 를 강제한다.
// jigLocal 과 독립 스위치(서버 계약 §0). 켜기 전 게이트는 처리방침·서버 배포(계약 §8).
export function isJigWebOn(features, userData, email) {
    if (!features) return false;
    if (features.jigWeb === true) return true;
    return isBetaUser(features, userData, email);
}

// 🏭 CNC 파트너(제조사) 화면 스위치 (2026-10-23, 시뮬레이션 [상]1 — 배포 사고 방지)
//   config/features.partnerHome === true 일 때만 제조사 로그인 착지 /partner · 목차 「CNC 파트너」 · 가입 「제조사」 카드가 열린다.
//   OFF(기본)면 제조사는 기존 화면(/outsource-order) 그대로. 관리자는 OFF여도 /partner 미리보기 가능(라우트만, 착지·목차는 그대로).
//   지금 파트너 화면은 샘플 데이터 — 실제 데이터 연결 전에는 켜지 말 것.
//   미리보기 계정: config/features.partnerHomeUserIds 에 든 uid(제조사 대표·직원이면 회사 uid 도)는 OFF여도 열린다 — 테스트 계정용(10-23)
export function isPartnerHomeOn(features, userData) {
    if (features?.partnerHome === true) return true;
    const ids = Array.isArray(features?.partnerHomeUserIds) ? features.partnerHomeUserIds : [];
    if (!userData || !ids.length) return false;
    return [userData.uid, userData.id, userData.companyId].some((x) => x && ids.includes(x));
}

// 완성 디자인 STL 웹 보관 화면 노출 여부 (2026-10-20) — config/features.designResults === true 단독(strict, 베타·관리자 미리보기 없음).
// 서버(functions/lib/design-results.js)가 fail-closed 이중 게이트(designResults + 처리방침 시행일)이므로 화면도 같은 플래그만 본다.
// features 미로딩(null)이면 잠금. 화면(/design-results)에는 환자정보가 보인다 — designResults(본인 labId) 문서 + rules 로 본인만 read.
export function isDesignResultsOn(features) {
    return features?.designResults === true;
}

// 첫 방문 등록 수신 노출 여부 (2026-09-30) — config/features.patientIntake === true 만. 베타·관리자 미리보기 없음(strict).
// features 미로딩(null)이면 잠금. 사용처: ClinicToday 첫 방문 등록 카드, SettingsHub·ClinicIntakeFields 설정 섹션
export function isPatientIntakeOn(features) {
    return features?.patientIntake === true;
}

// 환자앱 등록 경로 v2(앱에서 치과 선택 등록) 서버 스위치 조회 — config/features.patientSelfRegister === true 만(strict).
// 웹에는 이 키로 여는 화면이 없다(확인·거절·목록은 플래그 무관 — 계약 v2 §A-5). 앱·관리 화면 참고용으로만 둔다.
export function isPatientSelfRegisterOn(features) {
    return features?.patientSelfRegister === true;
}

// 웹 접수 화면 노출 여부 (2026-10-01) — config/features.clinicWalkin === true 단독(최종 검토 P2-1: patientSelfRegister OR 제거 —
// 두 기능은 별개 스위치. 서버 submit/resolve 도 clinicWalkin 키만 본다). 베타·관리자 미리보기 없음(strict). features 미로딩(null)이면 잠금.
// 사용처: /walkin/:slug 공개 페이지, SettingsHub·ClinicWalkinQr 설정, ClinicToday 접수 카드
export function isClinicWalkinOn(features) {
    return features?.clinicWalkin === true;
}

// 재내원 안내(리콜) 화면 노출 여부 (2026-10-01) — config/features.clinicRecall === true(strict) 이고 치과 환자관리가 열려 있을 때만.
// 베타·관리자 미리보기 없음(서버도 플래그 OFF면 feature-off). features 미로딩(null)이면 잠금.
// 사용처: MainLayout 치과 메뉴 '재내원 안내', App.js /clinic-recalls 라우트, ClinicPatientDetail [다음 안내 시기]
export function isClinicRecallOn(features, userData, email) {
    if (features?.clinicRecall !== true) return false;
    return isClinicPatientsOn(features, userData, email);
}

// 「치과 안내 보내기」(알림 파트 B — 휴진·진료시간 변경 등 고정 템플릿 5종) 노출 여부 (2026-10-08, 기획서_환자자동관리_알림파트_2026-10-07 §4-2)
//   config/features.clinicNotify === true(strict) 이고 치과 환자관리가 열려 있을 때만. 베타·관리자 미리보기 없음. features 미로딩(null)이면 잠금 — OFF면 B 블록 비노출·CF 호출 0.
//   사용처: ClinicAlerts B·C 「보낸 안내」, App.js /patients/alerts 라우트(isClinicAlertsOn), ClinicPatients 머리 [알림 설정·보내기]
export function isClinicNotifyOn(features, userData, email) {
    if (features?.clinicNotify !== true) return false;
    return isClinicPatientsOn(features, userData, email);
}

// 「알림」 파트 페이지(/patients/alerts) 노출 여부 — 검진 시기 안내(clinicRecall) 또는 치과 안내(clinicNotify) 중 하나라도 열려 있을 때. 블록 A/B 는 각 플래그로 따로 숨긴다
export function isClinicAlertsOn(features, userData, email) {
    return isClinicRecallOn(features, userData, email) || isClinicNotifyOn(features, userData, email);
}

// 「장착 후 확인」 화면 노출 여부 (2026-10-02) — config/features.patientFeedback === true(strict) 이고 치과 환자관리가 열려 있을 때만.
// 베타·관리자 미리보기 없음(서버도 플래그 OFF면 feature-off). features 미로딩(null)이면 잠금 — OFF면 CF 호출 자체를 하지 않는다.
// 사용처: ViewOrder 「장착 후 확인」 카드, ClinicPatientDetail 제작 기록 요약 줄, ClinicToday 「확인 필요」 카드, SettingsHub·ClinicFeedbackSettings 설정
export function isPatientFeedbackOn(features, userData, email) {
    if (features?.patientFeedback !== true) return false;
    return isClinicPatientsOn(features, userData, email);
}

// 치과 「접수」 노출 여부 (2026-10-03) — config/features.deskReception === true 단독(strict). 베타·관리자 미리보기 없음. features 미로딩(null)이면 잠금.
// 사용처: MainLayout 치과 메뉴 3곳 '접수', App.js /reception 라우트, /walkin/:slug 공개 페이지, CreateOrder 「오늘 접수」, ViewOrder 접수 연결 줄, ClinicWalkinQr 게이트(clinicWalkin OR)
export function isDeskReceptionOn(features) {
    return features?.deskReception === true;
}

// 덴클 케어 치과 웹 화면 노출 여부 (2026-10-04) — config/features.careApp === true 단독(strict). 베타·관리자 미리보기 없음. features 미로딩(null)이면 잠금.
// 사용처: ClinicPatients 「환자 앱 등록 처리위탁 확인」 카드, ClinicToday·DeskReception 「새 앱 등록 N명」
export function isCareAppOn(features) {
    return features?.careApp === true;
}

// 덴클 케어 스토어 출시 플래그 (2026-10-04) — 스토어 주소 유무는 config/careApp.js isCareStoreReady 가 함께 본다
export function isCareAppStoreLive(features) {
    return features?.careAppStoreLive === true;
}

// 덴클 케어 「치과 찾기」 운영 플래그 (2026-10-05, 정본 v2.6 §4-2) — strict. features 미로딩(null)이면 꺼짐(현행 문구)
export function isCareSearchLive(features) {
    return features?.careSearchLive === true;
}

// 「진료 후 질문」(질문 로드맵 엔진) 치과 웹 노출 여부 (2026-10-06) — config/features.roadmapEngine === true(strict) 이고 치과 환자관리가 열려 있을 때만.
// 베타·관리자 미리보기 없음(서버도 플래그 OFF면 feature-off). features 미로딩(null)이면 잠금 — OFF면 CF 호출 자체를 하지 않는다.
// 사용처: ClinicPatientDetail [진료 끝 ▾], DeskReception [진료 끝], ClinicPatients 「질문 답」 탭, MainLayout '환자 관리' 배지, SettingsHub·ClinicRoadmapSettings 설정, StaffInviteManagement T-18 고지
export function isRoadmapEngineOn(features, userData, email) {
    if (features?.roadmapEngine !== true) return false;
    return isClinicPatientsOn(features, userData, email);
}

// 치과 「기간 예상 기공료」 카드 노출 여부 (2026-10-07) — config/features.clinicExpectedStatement === true 단독(strict). 베타·관리자 미리보기 없음.
// features 미로딩(null)이면 잠금 — OFF면 카드 비노출·CF 호출 0 (서버는 2차 방어 feature-off).
// 사용처: TransactionStatementList 치과 분기 「기간으로 예상 기공료 보기」 카드
export function isClinicExpectedStatementOn(features) {
    return features?.clinicExpectedStatement === true;
}

// 「기간 예상 기공료」 오픈 예정일 표시용 문자열 (2026-10-07 대표 결정: 오픈일은 배포 후 정함 → config/features.clinicExpectedStatementOpenAt 로 읽어 표시)
//   ISO 문자열('2026-10-20' · '2026-10-20T00:00:00+09:00') · ms 숫자 · Timestamp 허용. 없거나 형식 오류면 null(호출처가 "곧"으로 표시).
//   반환 예: '2026년 10월 20일'. 게이트가 아니라 문구 치환 전용 — 실제 켜짐은 clinicExpectedStatement 플래그.
export function getClinicExpectedStatementOpenAtText(features) {
    const v = features?.clinicExpectedStatementOpenAt;
    if (v === undefined || v === null || v === '') return null;
    let d = null;
    if (typeof v === 'number') d = new Date(v);
    else if (typeof v === 'string') {
        // 'YYYY-MM-DD' 만 오면 UTC 자정으로 해석돼 날짜가 하루 밀릴 수 있어 로컬 날짜로 직접 조립
        const m = v.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
        d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(v);
    }
    else if (typeof v.toDate === 'function') d = v.toDate();
    else if (typeof v.seconds === 'number') d = new Date(v.seconds * 1000);
    if (!d || !Number.isFinite(d.getTime())) {
        console.error('[features] clinicExpectedStatementOpenAt 형식 오류 — "곧"으로 표시:', v);
        return null;
    }
    return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일`;
}

// 치과 「원장 호출」 노출 여부 (2026-10-08) — config/features.doctorCall === true 단독(strict). 베타·관리자 미리보기 없음. features 미로딩(null)이면 잠금.
// 사용처: DeskReception 3번째 카드, App.js /call 라우트, MainLayout 데스크 띠, SettingsHub·DoctorCallSettings(/settings/doctor-call)
export function isDoctorCallOn(features) {
    return features?.doctorCall === true;
}

// 치과 「예약」 노출 여부 (2026-10-11) — config/features.careBooking === true(strict) 이고 치과 환자관리가 열려 있을 때만. 베타 미리보기 없음. features 미로딩(null)이면 잠금.
// ⚠️ 이것만으로 메뉴를 보이지 않는다 — 파일럿·위탁 판은 서버 getClinicBookingSettings().available 로 판정(useBookingAvailable, fail-closed).
// 사용처: utils/useBookingAvailable(MainLayout 「예약」 메뉴·배지, App.js /patients/bookings, ClinicPatientDetail [본원 환자 확인])
export function isCareBookingOn(features, userData, email) {
    if (features?.careBooking !== true) return false;
    return isClinicPatientsOn(features, userData, email);
}

// 케어 앱 접수 표시 여부 (2026-10-11) — config/features.careAppReception === true(strict). 웹은 접수 화면 하단 안내 문구에만 쓴다(앱 접수 건 배지는 데이터 기준).
export function isCareAppReceptionOn(features) {
    return features?.careAppReception === true;
}

// 외주 의뢰서 확장 — 제조 의뢰(일반 보철·지르코니아·CNC·Metal print·기타) 통합 페이지 (2026-10-13 대표 "전부 바로 진행", 계획 docs/계획_외주의뢰서확장_2026-10-13.md §1-2).
//   config/features.outsourceMf === true 또는 베타 계정(미리보기). 기본 OFF, config 미생성. 오픈 = 약관 v7.1 고지 30일·변호사 확인 뒤 대표가 켬(배포 불필요).
//   베타도 실제로 의뢰를 보내려면 rules 가 보낸 기공소 대표의 약관 v7.1 동의 기록을 본다(그 전에는 화면만 보이고 보내기는 거부).
//   CNC 업체에 환자 실명 = config/features.outsourceMfCncName(기본 OFF — 약관 v7.1 게시 + 변호사 V-1 회신 뒤).
export function isOutsourceMfOn(features, userData, email) {
    if (!features) return false;
    if (features.outsourceMf === true) return true;
    return isBetaUser(features, userData, email);
}

// 재택 디자이너·CAD 디자인 숨김 (2026-10-25 대표 지시 "재택디자이너와 CAD 디자인은 사이트랑 에이전트에서 숨김, STL 종류만 열어둠").
//   config/features.homeWorkHidden === true → 재택 디자이너 메뉴·/home-work 숨김(베타 포함). cadDesignHidden === true → 허브 「CAD 디자인」 탭·진입 숨김.
//   기능·데이터·약관 조항은 그대로(숨김 ≠ 종료). 되돌리기 = 플래그 삭제(배포 불필요). features 미로딩(null)이면 숨기지 않는다(깜빡임 방지는 호출부).
export function isHomeWorkHidden(features) { return features?.homeWorkHidden === true; }
export function isCadDesignHidden(features) { return features?.cadDesignHidden === true; }

// 치과 「환자 공개 범위」 카드 노출 여부 (2026-10-14) — config/features.clinicPatientShareUi === true 단독(strict). 베타·관리자 미리보기 없음.
// features 미로딩(null)이면 잠금 — OFF면 카드·페이지 비노출, CF 호출 0. 사용처: SettingsHub 카드, settings/ClinicPatientShareSettings
export function isClinicPatientShareUiOn(features) {
    return features?.clinicPatientShareUi === true;
}

// 3D 모델 생성 허용 기공소 (2026-10-30 대표 결정 — 아이반기공소만). config/features.modelAllowedLabIds = [labUid, ...]
//   코드 기본값 = 빈 배열(아무도 못 씀). 서버 model-queue·jig-queue 도 같은 목록으로 거부(failed-precondition 'model-not-open').
//   웹 Jig.js 는 목록에 없으면 모델 버튼·선택지를 숨기고 "3D 모델 · 준비 중" 배지만 보인다.
export function isModelAllowedLab(features, labId) {
    if (!labId) return false;
    if (features?.modelOpenAll === true) return true;   // 2026-11-02 대표 "구독 기공소 전체" — 서버 jig-queue modelOpenFor 와 같은 판정(구독은 서버가 확인)
    const list = features?.modelAllowedLabIds;
    return Array.isArray(list) && list.includes(labId);
}
